// SPDX-License-Identifier: AGPL-3.0-or-later

import {publishCoretCallHeartbeat} from '@app/features/coret/CoretMediaApi';
import MediaEngine from '@app/features/voice/engine/MediaEngineFacade';
import {observer} from 'mobx-react-lite';
import {useEffect} from 'react';

export const CORET_SHOP_UPDATED_EVENT = 'coret-shop-updated';
export const CORET_ECONOMY_UPDATED_EVENT = 'coret-economy-updated';

export const CoretCallRewards = observer(() => {
	const connected = MediaEngine.connected;
	const channelId = MediaEngine.channelId;

	useEffect(() => {
		if (!connected || !channelId) return;
		let active = true;
		const publish = async () => {
			try {
				const state = await publishCoretCallHeartbeat(channelId);
				if (active) window.dispatchEvent(new CustomEvent(CORET_ECONOMY_UPDATED_EVENT, {detail: state}));
			} catch {
				// A próxima batida tenta novamente sem interromper a chamada.
			}
		};
		void publish();
		const interval = window.setInterval(() => void publish(), 30_000);
		return () => {
			active = false;
			window.clearInterval(interval);
		};
	}, [connected, channelId]);

	return null;
});
